<fieldset [formGroup]="group" class="in-one-column">
  <legend class="small-legend">{{ TITLE + "TITLE" | translate }}:</legend>

  <mat-form-field>
    <app-easy-checkbox
      formControlName="distilled"
      [label]="TITLE + 'DISTILLED' | translate"
    ></app-easy-checkbox>
  </mat-form-field>

  <!-- sugar fields -->

  <div class="in-one-column" formGroupName="sugarContentProperties">
    <mat-form-field>
      <app-easy-checkbox
        formControlName="containsAddedSugar"
        [label]="CONTAINS_ADDED_SUGAR | translate"
        (ngModelChange)="onSweetenerOrSugarChangedAlcoholic()"
      ></app-easy-checkbox>
    </mat-form-field>

    <mat-form-field>
      <app-easy-checkbox
        formControlName="containsAddedSweetener"
        [label]="CONTAINS_ADDED_SWEETENER | translate"
        (ngModelChange)="onSweetenerOrSugarChangedAlcoholic()"
      ></app-easy-checkbox>
    </mat-form-field>
  </div>

  <div class="in-two-columns" formGroupName="sugarContentProperties">
    <mat-form-field>
      <app-easy-select
        formControlName="sugarContentType"
        [label]="SUGAR_CONTENT_TYPE | translate"
        [translatePrefixForSelected]="'PRODUCTS.SUGAR_CONTENT_TYPE.'"
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [hasEmptyOption]="false"
        [options]="alcoholicSugarContentType"
      >
      </app-easy-select>
    </mat-form-field>

    <mat-form-field
      *ngIf="
        getCtrl(
          'sugarContentProperties.sugarContentInGramsPerHundredMilliliters'
        )
      "
    >
      <app-easy-input
        formControlName="sugarContentInGramsPerHundredMilliliters"
        [label]="SUGAR_CONTENT_IN_GRAMS_PER_HUNDRED_MILLILITERS | translate"
        type="number"
        [labelInfo]="'PRODUCTS.SUGAR_CONTENT_FIELDS.INFO' | translate"
        step="1"
        min="0"
        max="100"
      >
      </app-easy-input>
    </mat-form-field>
  </div>

  <!-- !sugar fields -->
</fieldset>
